






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired, validateExclusion } from '@/components/UI/Form/Validations';
import DeepCopy from '@/decorators/deep-copy';
import { GQL_PaymentMethodCreate, GQL_PaymentMethodUpdate } from '@/queries/global';
import PermissionService from '@/utils/permission-service';

@Component
export default class PaymentMethodForm extends Vue {
  @Prop({ required: true, type: Object }) private data!: GQL_PaymentMethodCreate | GQL_PaymentMethodUpdate;
  @DeepCopy('data') private formData!: GQL_PaymentMethodCreate | GQL_PaymentMethodUpdate;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) private query!: any;

  private PermissionService = PermissionService;
  private validForm = true;

  private rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('PaymentMethod', 'name') }),
      },
      {
        validation: validateExclusion(';'),
        message: i18n => i18n.t('PaymentMethod.nameHasSemicolon'),
      },
    ],
  };

  @Emit()
  private mutationDone() {}
}
